import { create } from 'zustand';
import type { Investment } from './types';

/**
 * Estado global do drawer da ficha do Investimento (Portfólio v2). Guarda o Investment clicado;
 * a ficha (rodadas, equipe, tags) é buscada por GET dentro do drawer. Global (zustand) — espelha o
 * dealDrawerStore — porque o clique pode vir da tabela do Portfólio ou da sidebar.
 */
interface InvestmentDrawerState {
  investment: Investment | null;
  openInvestment: (investment: Investment) => void;
  closeInvestment: () => void;
}

export const useInvestmentDrawer = create<InvestmentDrawerState>()((set) => ({
  investment: null,
  openInvestment: (investment) => set({ investment }),
  closeInvestment: () => set({ investment: null }),
}));
